"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function cleanDataFromPromoVideo(data) {
  const newData = Object.assign({}, data);
  delete newData.clips;
  return newData;
}

var _default = cleanDataFromPromoVideo;
exports.default = _default;